import { IframeFak } from 'ui/components';

export const IframeFakFeature: React.FC<Umbraco.IframeFak> = ({ content }) => {
	return <IframeFak {...content?.properties} />;
};
